/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ImageWidgetConfiguration extends models.WidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("ImageWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ImageWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ImageWidgetConfiguration>): ImageWidgetConfiguration {
        let obj = Object.assign(new ImageWidgetConfiguration(), model);
        ImageWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ImageWidgetConfiguration>): ImageWidgetConfiguration {
        if (!model) return null;
        return ImageWidgetConfiguration.newInstance(<ImageWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ImageWidgetConfiguration) {
        if (!obj) return;

        models.ImageWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ImageWidgetConfiguration): boolean {
        if (models.WidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ImageWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.image) {
            models.BrandingConfiguration.fixupPrototype(this.image);
        }
    }

    image: models.BrandingConfiguration;

}
